module.exports = __webpack_public_path__ + "static/cara-38e092fcf776d6a7c56891b63452134d.svg";